'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:selectBorrowFacilitiesController
 * @description
 * # selectBorrowFacilitiesController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('selectBorrowFacilitiesController', ['$uibModalInstance', '$scope', 'data',
      function ($uibModalInstance, $scope, data) {

          $scope.data = data;

          $scope.close = function () {
              $uibModalInstance.close($scope.selectedOptions);
          };

          $scope.dismiss = function () {
              $uibModalInstance.dismiss();
          };

      }]);